import React from 'react';
import styled from 'styled-components';
import { Container, Heading, Text } from '../primitives';
import { tokens } from '../../config/themeTokens';

const Wrapper = styled.section`
  padding: ${tokens.spacing.section} 0;
`;

const Split = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${tokens.spacing.xxl};
  align-items: center;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Side = styled.div``;

export function SplitContentSection({ title, body, left, right, children }) {
  return (
    <Wrapper>
      <Container>
        {title && <Heading level={2}>{title}</Heading>}
        {body && <Text>{body}</Text>}
        <Split>
          <Side>{left}</Side>
          <Side>{right}</Side>
        </Split>
        {children}
      </Container>
    </Wrapper>
  );
}

export default SplitContentSection;
